import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
// export interface getItemsFromAlgoliaProps {
//   type:string,indexName:string,tags:string[],attribute:string[]
// }

//type: string, indexName: string, tags: string[], attribute: string[]
import algoliasearch from 'algoliasearch';
import { get, canUseDOM } from './index';
import algoliaDefaultSettings from '../algoliaDefaultSettings.json';
// const ALGOLIA_INDEXNAME = 'uat_vd_en';
var buildTagField = function buildTagField(field, value, score) {
  var fieldFilter = "".concat(field, ":").concat(value);
  if (score) {
    fieldFilter += "<score=".concat(score, ">");
  }
  return fieldFilter;
};
export var loadCategoryAlgoliaResults = function loadCategoryAlgoliaResults(matchedCategories, type, searchCount, tags, curatorTags, filters, ALGOLIA_INDEXNAME, isTagsRule) {
  return new Promise(function (resolve) {
    // The field that contains tags to match against
    var tagField = 'tags';
    var ALGOLIA_APPID;
    var ALGOLIA_APIKEY;
    if (canUseDOM) {
      ALGOLIA_APPID = get(window, 'algoliaSettings.id') || algoliaDefaultSettings.id;
      ALGOLIA_APIKEY = get(window, 'algoliaSettings.key') || algoliaDefaultSettings.key;
    }
    // How many matches the user has, plus one because the default
    // score for Algolia is 1 on a match so boost above that slightly.
    var matchedCount = matchedCategories.length + 1;

    // Build pieces that will be passed and OR'ed together by Algolia
    var queryPieces = matchedCategories.map(function (category, index) {
      var filter = buildTagField(tagField, category, matchedCount - index);
      return filter;
    });

    // Build a fallback condition so we don't filter out anything from queries.
    var fallbackCondition = buildTagField(tagField, '-tag');

    // Init the client and index.
    var client = algoliasearch(ALGOLIA_APPID, ALGOLIA_APIKEY);
    var index = client.initIndex(ALGOLIA_INDEXNAME);

    // Perform a search using the condition
    index.search('', {
      sumOrFiltersScores: false,
      // This tells Algolia to add the filter tag scores together so we get a "total" weight
      getRankingInfo: true,
      // Used to sort client side, highest scored item likely will not be at the top.
      hitsPerPage: searchCount,
      // facetFilters: [...filters, [...queryPieces, fallbackCondition]], // Query filters.
      //  ...filters,
      facetFilters: isTagsRule ? tags : [type, tags, curatorTags, [].concat(_toConsumableArray(queryPieces), [fallbackCondition])],
      // Query filters.
      filters: filters
    }).then(function (response) {
      // Extract the results and do a pass of sorting clientside.
      var hits = response.hits;
      hits.sort(function (a, b) {
        return b._rankingInfo.filters - a._rankingInfo.filters;
      });
      resolve(hits);
    });
  });
};
var makeCancelable = function makeCancelable(promise) {
  var hasCanceled_ = false;
  var wrappedPromise = new Promise(function (resolve, reject) {
    promise.then(function (val) {
      return hasCanceled_ ? reject({
        isCanceled: true
      }) : resolve(val);
    });
    promise.catch(function (error) {
      return hasCanceled_ ? reject({
        isCanceled: true
      }) : reject(error);
    });
  });
  return {
    promise: wrappedPromise,
    cancel: function cancel() {
      hasCanceled_ = true;
    }
  };
};
var getListing = function getListing(indexName, itemFilters, querySearch) {
  var sumOrFiltersScores = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var host = '';
  if (canUseDOM) {
    host = window.location.href.split('#')[0].split('?')[0].substring(window.location.href.split('#')[0].split('?')[0].lastIndexOf('/') + 1);
  }
  return new Promise(function (resolve, reject) {
    import('./algolia').then(function (mod) {
      return mod.default;
    }).then(function (algoliaModule) {
      return algoliaModule.getIndex(indexName);
    }).then(function (index) {
      return index.search(typeof querySearch === 'undefined' ? _objectSpread({
        sumOrFiltersScores: sumOrFiltersScores,
        // This tells Algolia to add the filter tag scores together so we get a "total" weight
        getRankingInfo: true
      }, itemFilters) : querySearch);
    }).then(function (response) {
      resolve(response);
    }).catch(function (error) {
      reject(error);
      // console.error(error);
    });
  });
};
export var cancelableAlgoliaPromise = null;
export var getListingCancelable = function getListingCancelable(indexName, itemFilters, querySearch) {
  var sumOrFiltersScores = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var host = '';
  if (canUseDOM) {
    host = window.location.href.split('#')[0].split('?')[0].substring(window.location.href.split('#')[0].split('?')[0].lastIndexOf('/') + 1);
  }
  if (cancelableAlgoliaPromise) {
    cancelableAlgoliaPromise.cancel();
  }
  var promise = new Promise(function (resolve, reject) {
    import('./algolia').then(function (mod) {
      return mod.default;
    }).then(function (algoliaModule) {
      return algoliaModule.getIndex(indexName);
    }).then(function (index) {
      return index.search(typeof querySearch === 'undefined' ? _objectSpread({
        sumOrFiltersScores: sumOrFiltersScores,
        // This tells Algolia to add the filter tag scores together so we get a "total" weight
        getRankingInfo: true,
        // Used to sort client side, highest scored item likely will not be at the top.
        ruleContexts: itemFilters.facetFilters ? itemFilters.facetFilters[0] ? itemFilters.facetFilters[0][0] ? ["".concat(itemFilters.facetFilters[0][0].replace('type:', ''), "-").concat(host)] : ["".concat(itemFilters.facetFilters[0][0], "-").concat(host)] : '' : ''
      }, itemFilters) : querySearch);
    }).then(function (response) {
      resolve(response);
    }).catch(function (error) {
      reject(error);
      // console.error(error);
    });
  });
  cancelableAlgoliaPromise = makeCancelable(promise);
  return cancelableAlgoliaPromise;
};
export default getListing;
export var formatTagsRuleToFilters = function formatTagsRuleToFilters(tagsRule) {
  var facetsFilters = [];
  if (tagsRule) {
    var parsedTR = JSON.parse(tagsRule);
    if (parsedTR.length) {
      parsedTR.forEach(function (rule) {
        facetsFilters.push(rule);
      });
    }
  }
  return facetsFilters;
};
export var formatTagsRuleToFiltersOneByOne = function formatTagsRuleToFiltersOneByOne(tagsRule, tagsArray) {
  if (tagsRule) {
    var parsedTR = JSON.parse(tagsRule);
    if (parsedTR.length) {
      parsedTR.forEach(function (rule) {
        tagsArray.push(rule);
      });
    }
  }
  return tagsArray;
};
export var generateSeeMoreTagsFromRules = function generateSeeMoreTagsFromRules(tagsRule) {
  var facetsFilters = [];
  if (tagsRule) {
    var parsedTR = JSON.parse(tagsRule);
    if (parsedTR.length) {
      parsedTR.forEach(function (tagsArray) {
        tagsArray.forEach(function (rule) {
          facetsFilters.push({
            name: '',
            id: '',
            title: {
              jss: {
                value: rule.replace('tags:', '')
              }
            }
          });
        });
      });
    }
  }
  return facetsFilters;
};
export var isTagsRule = function isTagsRule(rule) {
  return rule && JSON.parse(rule).length > 0;
};